(function () {
    'use strict';

    /**
     * @desc Reusable verification code input directive for multi-character code entry
     * @example <elb-verification-code-input
     *              data-ng-model="vm.codeValue"
     *              data-input-count="6"
     *              data-input-type="numeric"
     *              data-has-error="vm.wrongCode"
     *              data-ng-required="true"
     *              data-input-id-prefix="code"
     *          ></elb-verification-code-input>
     *
     * @param ngModel - The model to bind the complete code string to
     * @param inputCount - Number of input fields (default: 6)
     * @param inputType - 'numeric', 'alphanumeric', or 'alpha' (default: 'alphanumeric')
     * @param hasError - Boolean to indicate error state for styling
     * @param ngRequired - Whether the input is required
     * @param inputIdPrefix - Prefix for input field IDs (default: 'code')
     * @param onComplete - Callback function when all inputs are filled
     */
    angular
        .module('elogbooksDirectives')
        .directive('elbVerificationCodeInput', elbVerificationCodeInput);

    elbVerificationCodeInput.$inject = ['$timeout'];

    function elbVerificationCodeInput($timeout) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                inputCount: '<?',
                inputType: '@?',
                hasError: '<?',
                inputIdPrefix: '@?',
                onComplete: '&?'
            },
            templateUrl: '/modules/directives/form-elements/verification-code-input/verification-code-input.html',
            link: function (scope, element, attrs, ngModelCtrl) {
                // Defaults
                scope.inputCount = scope.inputCount || 6;
                scope.inputType = scope.inputType || 'numeric';
                scope.inputIdPrefix = scope.inputIdPrefix || 'code';
                scope.inputs = [];
                scope.pasted = false;

                // Initialize inputs array
                initializeInputs();

                function initializeInputs() {
                    scope.inputs = new Array(scope.inputCount).fill('');
                }

                // Get the pattern based on input type
                function getFilterPattern() {
                    switch (scope.inputType) {
                        case 'numeric':
                            return /[^0-9]/g;
                        case 'alpha':
                            return /[^a-zA-Z]/g;
                        case 'alphanumeric':
                        default:
                            return /[^a-zA-Z0-9]/g;
                    }
                }

                // Filter input based on type
                function filterInput(value) {
                    if (!value) return '';
                    return value.replace(getFilterPattern(), '');
                }

                // Update the ngModel with combined value
                function updateModel() {
                    var combinedValue = scope.inputs.join('');
                    ngModelCtrl.$setViewValue(combinedValue);

                    // Check if complete and call callback
                    if (combinedValue.length === scope.inputCount && scope.onComplete) {
                        $timeout(function() {
                            scope.onComplete({ value: combinedValue });
                        });
                    }
                }

                // Watch for external model changes
                ngModelCtrl.$render = function () {
                    var value = ngModelCtrl.$viewValue || '';
                    var filteredValue = filterInput(value);
                    for (var i = 0; i < scope.inputCount; i++) {
                        scope.inputs[i] = filteredValue[i] || '';
                    }
                };

                // Handle paste event
                scope.handlePaste = function ($event, index) {
                    $event.preventDefault();
                    scope.pasted = true;

                    var pastedData = ($event.originalEvent || $event).clipboardData.getData('text');
                    var filteredData = filterInput(pastedData);

                    if (filteredData.length > 0) {
                        // Distribute pasted characters starting from current index
                        var charIndex = 0;
                        for (var i = index; i < scope.inputCount && charIndex < filteredData.length; i++) {
                            scope.inputs[i] = filteredData[charIndex];
                            charIndex++;
                        }
                        updateModel();

                        // Focus on the next empty input, or the last filled input
                        var focusIndex = Math.min(index + filteredData.length, scope.inputCount - 1);
                        focusInput(focusIndex);
                    }
                };

                // Handle input changes (via ng-change)
                scope.handleChange = function (index) {
                    var value = filterInput(scope.inputs[index] || '');

                    // Only take first character
                    scope.inputs[index] = value.charAt(0);

                    updateModel();

                    // Auto-focus next input if character was entered
                    if (value && !scope.pasted && index < scope.inputCount - 1) {
                        focusInput(index + 1);
                    }
                    scope.pasted = false;
                };

                // Handle keydown for navigation
                scope.handleKeydown = function ($event, index) {
                    var key = $event.key;
                    var input = $event.target;

                    switch (key) {
                        case 'Backspace':
                            if (!scope.inputs[index] && index > 0) {
                                // Move to previous and clear it
                                $event.preventDefault();
                                scope.inputs[index - 1] = '';
                                updateModel();
                                focusInput(index - 1);
                            } else if (scope.inputs[index]) {
                                // Clear current
                                scope.inputs[index] = '';
                                input.value = '';
                                updateModel();
                            }
                            break;
                        case 'ArrowLeft':
                            if (index > 0) {
                                $event.preventDefault();
                                focusInput(index - 1);
                            }
                            break;
                        case 'ArrowRight':
                            if (index < scope.inputCount - 1) {
                                $event.preventDefault();
                                focusInput(index + 1);
                            }
                            break;
                        case 'Delete':
                            scope.inputs[index] = '';
                            input.value = '';
                            updateModel();
                            break;
                    }
                };

                // Focus a specific input by index
                function focusInput(index) {
                    $timeout(function () {
                        var inputElement = element[0].querySelector('#' + scope.inputIdPrefix + '-' + index);
                        if (inputElement) {
                            inputElement.focus();
                            inputElement.select();
                        }
                    });
                }

                // Clear all inputs
                scope.clearInputs = function () {
                    initializeInputs();
                    updateModel();
                    focusInput(0);
                };

                // Generate array for ng-repeat
                scope.getInputIndices = function () {
                    var indices = [];
                    for (var i = 0; i < scope.inputCount; i++) {
                        indices.push(i);
                    }
                    return indices;
                };

                // Expose clear method on controller
                ngModelCtrl.$clear = scope.clearInputs;

                // Watch for inputCount changes
                scope.$watch('inputCount', function (newVal, oldVal) {
                    if (newVal !== oldVal) {
                        initializeInputs();
                        updateModel();
                    }
                });
            }
        };
    }
})();

